import { useEffect, useState } from "react"
import { useMutation, useQuery, useQueryClient } from "react-query"
import { Link, useLocation } from "react-router-dom"
import { toast } from "react-toastify"

import { PageTitle } from "../../../../../_metronic/layout/core"
import Authorization from "../../../../routing/Authorization"
import DeleteConfirmModal from "../../../../components/DeleteConfirmModal"
import GeneralPagination from "../../../../components/Pagination/GeneralPagination"

import { getVouchers, deleteVoucher } from "../../../../models/courses/vouchers"
import VoucherFilter from "./components/VoucherFilter"
import VoucherTable from "./components/VoucherTable/VoucherTable"
import { columnAliases } from "./components/VoucherTable/_columns"


const ManageVouchers = () => {
    const location = useLocation()

    const pageSize = 10
    const [showFilter, setShowFilter] = useState(false)
    const [filters, setFilters] = useState({
        batchId: location.state?.filters?.batch?.value
    })
    const [page, setPage] = useState(1)
    const [sortBy, setSortBy] = useState({})
    const [showDeleteVoucherModal, setShowDeleteVoucherModal] = useState()
    const [deleteVoucherData, setDeleteVoucherData] = useState({})

    const queryClient = useQueryClient()
    const { isLoading, isFetching, isError, error, data, isSuccess } = useQuery(['vouchers'], () => getVouchers({
        code: filters?.code,
        courseId: filters?.courseId,
        merchantId: filters?.merchantId,
        batchId: filters?.batchId,
        status: filters?.status,
        prakerjaOwner: filters?.prakerjaOwner,
        page,
        pageSize,
        sortBy
    }))
    const { mutate: deleteVoucherMutate, isLoading: deleteVoucherLoading } = useMutation(voucherId => deleteVoucher(voucherId), {
        onSuccess: () => {
            toast.success('Success')
            queryClient.invalidateQueries(['vouchers'])
        },
        onError: error => toast.error(error.message)
    })

    useEffect(() => {
        queryClient.fetchQuery(['vouchers'])
    }, [queryClient, filters, page, sortBy])

    return (
        <>
            <PageTitle>Vouchers</PageTitle>
            <div className="card">
                <div className="card-header p-6 d-block">
                    <div className="d-flex justify-content-between">
                        <button type="button" className={"btn btn-sm " + (showFilter ? 'btn-primary' : 'btn-light-primary')} onClick={() => setShowFilter(item => !item)}><i className="fa fa-filter"></i> Filter</button>
                        <div>
                            <Link to="/courses/vouchers/batch" state={{showGenerateVoucherModal: true}} className="me-3">
                                <button className="btn btn-sm btn-outline btn-outline-primary">Generate Vouchers</button>
                            </Link>
                            <Link to="/courses/vouchers/manage/create">
                                <button className="btn btn-sm btn-primary">Create Voucher</button>
                            </Link>
                        </div>
                    </div>
                    <VoucherFilter
                        show={showFilter}
                        queryClient={queryClient}
                        initialValues={{
                            batch: location.state?.filters?.batch
                        }}
                        onSubmit={values => {
                            setPage(1)
                            setFilters(values)
                        }}
                    />
                </div>
                <div className="card-body p-6">
                    <VoucherTable
                        isLoading={isFetching}
                        isError={isError}
                        error={error}
                        data={!isLoading ? data.data : []}
                        currentPage={page}
                        pageSize={pageSize}
                        onSortByChange={sortBy => setSortBy(() => {
                            if (sortBy.length) return {
                                id: sortBy[0].id in columnAliases ? columnAliases[sortBy[0].id] : sortBy[0].id,
                                direction: sortBy[0].desc ? 'DESC' : 'ASC'
                            }
                    
                            return {}
                        })}
                        onDelete={voucher => {
                            setShowDeleteVoucherModal(true)
                            setDeleteVoucherData(voucher)
                        }}
                    />
                    {isSuccess && <GeneralPagination
                        onPageChange={page => setPage(page)}
                        totalCount={data?.meta.total}
                        currentPage={page}
                        pageSize={pageSize}
                        from={data?.meta.from}
                        to={data?.meta.to}
                    />}
                </div>
            </div>

            <DeleteConfirmModal
                show={showDeleteVoucherModal}
                handleClose={() => setShowDeleteVoucherModal(false)}
                onConfirm={() => {
                    deleteVoucherMutate(deleteVoucherData.id)
                    setShowDeleteVoucherModal(false)
                    setDeleteVoucherData({})
                }}
                isConfirmLoading={deleteVoucherLoading}
                name={deleteVoucherData?.code}
            />
        </>
    )
}

export default Authorization(ManageVouchers, ['admin', 'officer'])